import React from 'react';

const EmptyState = ({ icon, title, subtitle, action, className = '' }) => (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className}`}>
        {icon ? (
            <span
                className="inline-flex items-center justify-center h-12 w-12 rounded-2xl mb-4"
                style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
            >
                {icon}
            </span>
        ) : null}
        <h3 className="text-sm font-bold text-[#1F2937]">{title}</h3>
        {subtitle ? <p className="mt-1 text-sm text-[#6B7280] max-w-sm">{subtitle}</p> : null}
        {action ? <div className="mt-4">{action}</div> : null}
    </div>
);

export default EmptyState;
